<div class="container-fluid">
  <div class="row ">
    <div class="card   crd col-md-2 sidenav content "  style="max-width: 10rem;">
     
      <div class="card-body ">
        
        <p class="card-text"><strong>  <ul class="nav nav-tab nav-stacked ">
          <li ><strong><h5><a  class=" active nav-link text-dark" (click)="rval=1">BOOK</a></h5> </strong></li>

          <li><strong><h5> <a class="active nav-link text-dark" (click)="rval=2">VIEW BOOKS</a></h5> </strong></li>
      
        </ul></strong></p>
        
      </div>
  
  
    </div> 
    
    
<div class="col-md-10" *ngIf="rval==1">

  <div class="col-md-5 r offset-3 bg-primary">
    
    <h3 class="text-light text-center"> ADD BOOK </h3>
 
  <form class="form" [formGroup]="bookform" (ngSubmit)="bookForm()"> <div class="form-group">
                                       
    <div class="form-group">
        <input type="text" class="form-control"  id="bookName" formControlName="bookName" placeholder="Book Name" value="" />
    </div>
    <div class="form-group">
        <input type="date" class="form-control"  id=" bookYear" formControlName="bookYear" placeholder="Book Year" value="" />
    </div>
    <div class="form-group">
        <input type="number" class="form-control"  id="bookPrice" formControlName="bookPrice" placeholder="Book Price (INR)" value="" />

    </div>
    <div class="form-group">
        <select class="form-control" id="branch" formControlName="branch"  >
          <option value="">CHOOSE BRANCH</option>
          <option >MECHANICAL</option>
          <option >COMPUTER_SCIENCE</option>
          <option >ELECTRICAL</option>
          <option >CIVIL</option>
          
        </select>
    </div>

    <div class="form-group">
        <select type="text" class="form-control" placeholder="semester*"  id="semester" formControlName='semester'>

          <option value="" [selected]="true">CHOOSE SEMESTER</option>
          <option value='SEMESTER1'>1</option>
          <option value='SEMESTER2'>2</option>
          <option value='SEMESTER3'>3</option>
          <option value='SEMESTER4'>4</option>
          <option value='SEMESTER5'>5</option>
          <option value='SEMESTER6'>6</option>
          <option value='SEMESTER7'>7</option>
          <option value='SEMESTER8'>8</option>
        
          
        </select>
       
    </div>
   <div class="text-center"> <button type="submit" class="btn btn-success text-center">Add Book</button></div>

</div>
<div><span class="text-danger"><h6>{{success}}</h6></span></div>
<div><span class="text-danger"><h6>{{error}}</h6></span></div>
</form></div>

      </div>
<div class="col-md-10 row" *ngIf="rval==2">
       

         <div class="card text-white mb-2 offset-1 " style="max-width: 18rem; background-color: #aa7398 ;opacity: 65%;" *ngFor="let book of bookList">
            <div class="card-header" ><Strong><h3>{{book.bookName}}</h3></Strong></div>
            <div class="card-body">
           <strong>
              <p class="card-text">Year Of Publised : {{book.bookYear}}</p>
              <p class="card-text">Price : {{book.bookPrice}}</p>
            
              <p class="card-text">Seller : {{book.customer.customerName}}</p>
              <p class="card-text">Contact No : {{book.customer.contactNumber}}</p></strong>   
            </div>
      
       
          </div>
          <h6 class="text-danger" *ngIf="error!=null">{{error}}</h6> 
          
        </div>
          
</div>



